module.exports = __webpack_public_path__ + "img/HQ-PA2W1S.8e994b6d.jpg";